module.exports = __webpack_public_path__ + "img/icons-arrow-down.b677d4de.svg";